import { request } from "./http";

export interface MlSignal {
  symbol: string;
  score: number;          // 0-100 bullish confidence
  label: "bullish" | "neutral" | "bearish";
  features: Record<string, number>;
  model_version: string;
  cached: boolean;
}

export interface MlAnomaly {
  symbol: string;
  timestamp: string;
  return_pct: number;
  z_score: number;
  severity: "warn" | "alert" | "critical";
}

export interface MlRecommendation {
  symbol: string;
  score: number;
  label: "bullish" | "neutral" | "bearish";
  realized_vol_pct: number;
  rank_score: number;
}

export const ml = {
  signal: (symbol: string) =>
    request<MlSignal>(`/api/v1/ml/signals/${encodeURIComponent(symbol)}`),
  anomaly: (symbol: string) =>
    request<MlAnomaly | null>(`/api/v1/ml/anomalies/${encodeURIComponent(symbol)}`),
  recommended: (
    direction: "bullish" | "bearish" | "any" = "bullish",
    topN: number = 10,
    assetClass?: string,
  ) => {
    const params = new URLSearchParams({
      direction,
      top_n: String(topN),
    });
    if (assetClass) params.set("asset_class", assetClass);
    return request<MlRecommendation[]>(`/api/v1/ml/recommended?${params.toString()}`);
  },
};
